export const ROUTES = {
    ROOT: '/',
    SIGN_IN: '/signin',
    PICKUP_LOCATION: '/pickup-location',
    COMPLETED_JOBS: '/completed-jobs',
    NEW_ACCOUNT: '/new-account',
    TERMS: '/terms',
    JOB_DETAILS: '/job-details',
    PUBLISHED_JOB: '/published-job',
    COMPLETED_JOB_DETAILED: '/completed-job',
    LOCATION_SEARCH: '/location-search',
    VIEW_BIDS: '/view-bids',
    REVIEW_HAULER: '/review-hauler',
    LOG_OUT: '/log-out',
    COMING_SOON: '/coming-soon',
    BID_ACCEPTED: '/bid-accepted',
    ADDITIONAL_ITEMS: '/additional-items',
    FORGOT_PASSWORD: '/forgot-password',
    PREFERENCES: '/preferences',
    CONTACT: '/contact-us',
    TUTORIAL: '/tutorial',
    SET_AVAILABITILY: '/set-availability',
    CHAT: '/chat',
    WAITING_FOR_CARD_AUTHORIZATION: '/waiting-for-card-authorization'
}

export const DEFAULT_ROUTE = ROUTES.PICKUP_LOCATION
export const SITE_URL = 'http://localhost:8080/#'

export const HELP_LINK = 'https://gotrashy.zendesk.com/hc/en-us/categories/360000571993-Customers'



// WEBPACK FOOTER //
// ./src/constants/routes.ts